import CommentComponent from "./CommentComponent";
import { Box } from "@mui/material";
import React from "react";

const CommentWrapper = ({ comment, setOpenDelete, deleteSelected }) => {
  return (
    <>
      <Box>
        <CommentComponent
          comment={comment}
          setOpenDelete={setOpenDelete}
          deleteSelected={deleteSelected}
        />
        {comment.commentReplies.length > 0
          ? comment.commentReplies.map((comment) => (
              <Box sx={{ marginLeft: "50px", marginTop: "5px" }}>
                <CommentComponent
                  comment={comment}
                  setOpenDelete={setOpenDelete}
                  deleteSelected={deleteSelected}
                />
              </Box>
            ))
          : ""}
      </Box>
    </>
  );
};

export default CommentWrapper;
